import React from 'react';
import PropTypes from 'prop-types';

export const gameProps = {
    game: PropTypes.shape({
        id: PropTypes.number.isRequired,
        // TODO: get arena location over venue. Want to display "Glendale, AZ"
        //arenaLocation: PropTypes.string,
        venue: PropTypes.string,
        arenaName: PropTypes.string,
        easternStartTime: PropTypes.string.isRequired,
        gameDate: PropTypes.string.isRequired,
        gameScheduleState: PropTypes.shape({
            id: PropTypes.number.isRequired,
            abbreviation: PropTypes.string.isRequired,
            shortName: PropTypes.string.isRequired
        }).isRequired,
        period: PropTypes.number,
        homeScore: PropTypes.number,
        visitingScore: PropTypes.number,
        homeTeam: PropTypes.shape({
            id: PropTypes.number.isRequired,
            placeName: PropTypes.string.isRequired,
            commonName: PropTypes.string.isRequired,
            triCode: PropTypes.string.isRequired
        }).isRequired,
        visitingTeam: PropTypes.shape({
            id: PropTypes.number.isRequired,
            placeName: PropTypes.string.isRequired,
            commonName: PropTypes.string.isRequired,
            triCode: PropTypes.string.isRequired
        }).isRequired,
        state: PropTypes.shape({
            id: PropTypes.number.isRequired
        }).isRequired,
        timeRemaining: PropTypes.string,
    }).isRequired
};